import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { uniqBy } from 'lodash';
import * as socialActions from '../../actions/social';
import * as planActions from '../../actions/plan';
import onClickOutside from 'react-onclickoutside';
import Modal from 'react-modal';
import NewPost from './NewPost';
import { StaggeredMotion, spring, presets } from 'react-motion';
import { ENHANCED_PLAN } from '../../constants/SiteVariables';

const modalStyles = {
  overlay: {
    zIndex: 1999,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    zIndex: 2000,
    backgroundColor: 'rgb(0, 0, 0, 0.75)',
    position: 'absolute',
    right: 0,
    bottom: 0,
    padding: '15px',
    margin: 0,
    width: '100%'
  }
};

class Navigation extends React.Component {
  state = {
    show: false,
    navItems: [{
      id: 'close',
      text: '',
      iconClass: 'icon-lv-cancel',
      onClickFn: ''
    }, {
      id: 'post',
      text: 'Create Post',
      iconClass: 'fa-file-text-o',
      onClickFn: this.props._social.newPost.bind(this, 'general')
    }]
  }

  componentWillReceiveProps(nextProps) {
    this.setupNav(nextProps);
  }

  setupNav = props => {
    if (!props.customer.get('loaded')) return false;

    const vendorId = props.customer.get('account').get('activeVendorId');
    const vendor = props.entities.get('vendors').get(vendorId);

    if (this.props.flag.get('specials')) {
      this.state.navItems.push({
        id: 'special',
        text: 'Create Special',
        iconClass: 'fa-star-o',
        onClickFn: this.props._social.newPost.bind(this, 'special')
      });
    }

    if (this.props.flag.get('deals') && (vendor && vendor.plan === ENHANCED_PLAN)) {
      this.state.navItems.push({
        id: 'deal',
        text: 'Create Deal',
        iconClass: 'fa-tags',
        onClickFn: this.props._social.newPost.bind(this, 'deal')
      });
    }

    this.setState({ navItems: uniqBy(this.state.navItems, n => n.id) });
  }

  handleClickOutside = () => {
    // need to give the state model time to mount before killing off the nav
    setTimeout(() => this.props._social.toggleNav(false), 40);
  }

  getNavStyles = prevStyles => {
    const endValue = prevStyles.map((_, i) => {
      return i === 0
        ? { y: 0, o: 0, tX: 100, r: 0 }
        : {
            y: spring(prevStyles[i - 1].y - 65, presets.stiff),
            o: spring(1),
            tX: spring(0),
            tR: spring(0, presets.wobbly),
          };
    });
    return endValue;
  }

  render() {
    if (!this.props.flag.get('social') || 
        !this.props.vendor ||
        this.props.vendor.hidden ||
        !this.props.auth.get('user').get('isLoggedIn')) return <div></div>;

    const { navItems } = this.state;
    const navLen = navItems.length;

    return (
      <div className="Navigation fixed-bottom">
        {!this.props.social.get('new').get('nav') &&
          <button
            className="btn-mobile-ui box-shadow pull-right btn-social-nav social-nav-toggle"
            onClick={() => this.props._social.toggleNav(!this.props.social.get('new').get('nav'))}
          >
            <span className="d-inline-flex flex-column justify-content-center align-items-center">
              <i className="btn-mobile-ui-icon fa fa-ellipsis-h" />
              <span className="sr-only btn-mobile-ui-text">Social Menu</span>
            </span>
          </button>}

        <Modal
          isOpen={this.props.social.get('new').get('nav')}
          closeTimeoutMS={150}
          className="modal-dialog"
          style={modalStyles}
          contentLabel="Social Navigation"
        >
          <StaggeredMotion
            defaultStyles={navItems.map((i) => ({
              y: 0,
              o: 0,
              tX: 100,
              tR: -90,
            }))}
            styles={this.getNavStyles}
          >
            {items =>
              <nav className="social-nav d-flex flex-column">
                {items.map(({ y, o, tX, tR, navItem }, i) =>
                  <div
                    key={navItems[i].id}
                    className={`social-nav-item social-nav-item-${navItems[i].id} d-flex align-items-center justify-content-end mt-3`}
                    style={{ transform: `translate3d(0,${y}px,0)`, zIndex: navLen - i }}
                    onClick={navItems[i].onClickFn}
                  >
                    {navItems[i].text &&
                      <span
                        className="social-nav-text mr-2"
                        style={{
                          transformOrigin: 'right',
                          transform: `translate3d(${tX}px, 0, 0) rotateZ(${tR}deg)`,
                          opacity: o
                        }}
                      >
                        {navItems[i].text}
                      </span>}
                    <button
                      className="btn-mobile-ui btn-social-nav box-shadow social-nav-toggle"
                      style={{ zIndex: 2 }}
                    >
                      <span className="d-inline-flex flex-column justify-content-center align-items-center">
                        <i
                          className={`btn-mobile-ui-icon fa ${navItems[i]
                            .iconClass}`}
                        />
                      </span>
                    </button>
                  </div>
                )}
              </nav>}
          </StaggeredMotion>  
        </Modal>

        {this.props.social.get('new').get('type') &&
          <NewPost {...this.props} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    customer: state.customer,
    entities: state.entities,
    flag: state.flag,
    social: state.social,
    vendor: state.entities
      .get('vendors')
      .get(state.customer
        .get('account')
        .get('activeVendorId'))
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _plan: bindActionCreators(planActions, dispatch),
    _social: bindActionCreators(socialActions, dispatch)
  };
}

export const NavigationContainer = connect(mapStateToProps, mapDispatchToProps)(
  onClickOutside(Navigation)
);



// WEBPACK FOOTER //
// ./src/components/Social/Navigation.js